import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import {LocationNode, NodeAvailabilityType} from './types';
import {byProp} from '@lib/utils';
import {ConnectionUser, WorkspaceReservation, getWorkspaceReservationSpaceNodeId} from '../../data';
import {Dictionary} from '@reduxjs/toolkit';
import {DeskAmenity, ActivityType} from '@lib/infrastructure';

export type SelectableWorkspaceWithGroupType = {
  nodeAvailability: string;
  areaId: string | undefined;
  title: string;
  floorId: string;
  subtitle: string;
  hasBookableDesks: boolean;
  connectedUsers: (ConnectionUser | undefined)[];
  nodeId: string | undefined;
  deskAmenities: DeskAmenity[];
  activityTypes: ActivityType[];
};

export const groupSelectableOfficeNodesByType = (selectableOfficeNodes: LocationNode[]) => {
  return map(
    groupBy(selectableOfficeNodes, (list) => list.nodeAvailability),
    (data, key) => {
      return {
        key: key as NodeAvailabilityType,
        data: data,
      };
    },
  ).sort(byProp('key'));
};

export const getConnectedUsersWithReservationInNode = (
  workspaceReservations: WorkspaceReservation[],
  connectedUserEntities: Dictionary<ConnectionUser>,
  node?: {id: string},
) => {
  return workspaceReservations.reduce<(ConnectionUser | undefined)[]>((acc, curr) => {
    if (node?.id && getWorkspaceReservationSpaceNodeId(curr) !== node.id) return acc;

    return [...acc, connectedUserEntities[curr.userId]];
  }, []);
};
